function prefersReducedMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
  var control = e.target.closest && e.target.closest('.video__control');
  if (!control) return;
  e.preventDefault();
  control.click();
});

function loadVideoSources(video, isMobile) {
  const sourcesData = isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
  video.querySelectorAll('source').forEach(s => s.remove());
  if (sourcesData) {
    sourcesData.split(',').forEach(sourceStr => {
      const [url, mimeType] = sourceStr.split('|');
      if (url && mimeType) {
        const sourceElement = document.createElement("source");
        sourceElement.src = url.trim();
        sourceElement.type = mimeType.trim();
        video.appendChild(sourceElement);
      }
    });
  }
  video.load();
}

function playVideoWithLowPowerFallback(video) {
  const container = video.closest('.video-container') || video.parentElement;
  const section = container.closest('[id^="shopify-section-"]') || container;
  const playControl = container.querySelector('.video__control.play');
  const pauseControl = container.querySelector('.video__control.pause');

  if (prefersReducedMotion()) {
    if (playControl) playControl.classList.remove('hidden');
    if (pauseControl) pauseControl.classList.add('hidden');
    return;
  }

  const playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch((error) => {
      if (error.name === 'NotAllowedError') {
        if (playControl) playControl.classList.add('hidden');
        if (pauseControl) pauseControl.classList.add('hidden');

        function handleFirstClick(e) {
          const rect = container.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right ||
              e.clientY < rect.top  || e.clientY > rect.bottom) return;

          e.preventDefault();
          e.stopPropagation();
          section.removeEventListener('click', handleFirstClick, true);

          if (playControl) playControl.classList.add('hidden');
          if (pauseControl) pauseControl.classList.remove('hidden');

          video.play().catch(() => {});
        }
        section.addEventListener('click', handleFirstClick, true);
      }
    });
  }
}

function loadAndPlay(video) {
  if (video.dataset.loaded === "true") return;
  // Videos injected after page load miss the inline reduced-motion strip in
  // video.liquid, so drop native autoplay here before sources are attached.
  if (prefersReducedMotion()) video.removeAttribute('autoplay');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  loadVideoSources(video, isMobile);
  video.dataset.loaded = "true";
  video.addEventListener('canplay', () => playVideoWithLowPowerFallback(video), { once: true });
}

// Single observer shared across every initLazyLoadingVideo() call (page load,
// variant swaps, section reloads) so repeated calls don't stack observers.
let lazyVideoObserver = null;
const observedLazyVideos = new Set();

function stopObservingLazyVideo(video) {
  lazyVideoObserver.unobserve(video);
  observedLazyVideos.delete(video);
}

function initLazyLoadingVideo() {
  // Release videos that were removed from the DOM (e.g. replaced gallery markup)
  // so the observer doesn't keep detached nodes alive.
  observedLazyVideos.forEach(video => {
    if (!video.isConnected) stopObservingLazyVideo(video);
  });

  const videos = document.querySelectorAll('.lazy-video-wrapper video:not([data-loaded="true"])');
  if (!videos.length) return;

  if (!lazyVideoObserver) {
    lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadAndPlay(entry.target);
        stopObservingLazyVideo(entry.target);
      });
    }, {
      rootMargin: "0px 0px 200px 0px"
    });
  }

  videos.forEach(video => {
    if (video.getBoundingClientRect().top < window.innerHeight + 200) {
      loadAndPlay(video);
      if (observedLazyVideos.has(video)) stopObservingLazyVideo(video);
    } else if (!observedLazyVideos.has(video)) {
      lazyVideoObserver.observe(video);
      observedLazyVideos.add(video);
    }
  });
}

function handleLowerPowerModeVideo() {
  document.querySelectorAll('.video-container:not(.lazy-video-wrapper)').forEach(container => {
    const videos = Array.from(container.querySelectorAll('video')).filter(video => video.id !== 'lowPowerDetectVideo');
    const video = videos.find(candidate => candidate.offsetParent !== null) || videos[0];
    if (video) playVideoWithLowPowerFallback(video);
  });
}

window.initLazyLoadingVideo = initLazyLoadingVideo;

document.addEventListener("DOMContentLoaded", function () {
  handleLowerPowerModeVideo();
  initLazyLoadingVideo();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => initLazyLoadingVideo());
  document.addEventListener('shopify:section:reorder', () => initLazyLoadingVideo());
}
